import { useEffect } from 'react';
import { useProjectLocalStorage } from 'utils/hooks/useProjectLocalStorage';
import { FolderPageNamespace } from '../types';
import { DEFAULT_FOLDER_ID } from '../constants';

/**
 * Stores the last visited folder ID to local storage or 0 if the folder is the root folder
 *
 * @param namespace - The prefix for the local storage key to avoid conflicts
 * @param folderId - The current folder ID
 * @param isInRootFolder - Whether the current folder is the root folder
 */
export const useStoreLastVisitedFolderId = (
  namespace: FolderPageNamespace,
  folderId = DEFAULT_FOLDER_ID,
  isInRootFolder = false,
) => {
  const [_, setLastVisitedFolderId] = useProjectLocalStorage(namespace, folderId);

  useEffect(() => {
    setLastVisitedFolderId(isInRootFolder ? DEFAULT_FOLDER_ID : folderId);
  }, [folderId, isInRootFolder]);
};
